import React from "react";
import {
  ADJUSTMENT_DECISION_BADGE_CLASSES,
  ADJUSTMENT_DECISION_LABELS,
  AdjustmentDecision,
  LIFESTYLE_ZONE_BADGE_CLASSES,
  LifestyleZone,
} from "../../types/checkin";
import { formatLabels } from "../../utils/formatters";
import { BADGE_PILL } from "../../utils/badgeColors";

// Shared by UserCheckInsCard and CheckInDetailsModal so they can't drift.

const NEUTRAL_BADGE =
  "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200";

export const AdjustmentDecisionBadge: React.FC<{
  decision: AdjustmentDecision;
}> = ({ decision }) => (
  <span
    className={`${BADGE_PILL} ${
      ADJUSTMENT_DECISION_BADGE_CLASSES[decision] || NEUTRAL_BADGE
    }`}
  >
    {ADJUSTMENT_DECISION_LABELS[decision] ?? formatLabels(decision)}
  </span>
);

export const LifestyleZoneBadge: React.FC<{
  zone: LifestyleZone | null;
  // The modal spells out the zone; the table column has no room
  suffix?: string;
}> = ({ zone, suffix }) => {
  if (!zone) {
    return <span className={`${BADGE_PILL} ${NEUTRAL_BADGE}`}>Not scored</span>;
  }

  return (
    <span className={`${BADGE_PILL} ${LIFESTYLE_ZONE_BADGE_CLASSES[zone]}`}>
      {suffix ? `${zone} ${suffix}` : zone}
    </span>
  );
};
